var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 18,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAABB0lEQVQ4jdWTQSsFYRiFH5eu8hsUWdrKklKy8SesWBC35FfIUsnGxr+glPI72OhaYOdyQ48+XjVu937z3dg4NfPOmc458zZzBrXkmFdv1IUSfYMyzABTMWtRGvrUM7MoDR0K/z90Gdiv8GbPTDgAVvu6B9RizS9cBZ8NPhf8MvhGP3+ub7thPFUX1Rd1RT2J+3uDvHVF3omAV7WjvgVv5Xzp1FQbGdGmP7Gd0Y6o4+mirR7VbLyl3sfmOd2hekfscFHwT08UaM5T2HelHgrq1ynQPFZ72i0wlOA5adKLFbgFJv8g9BqYHgPWgWOgDZwB7+lhQwSlpUaBpVisVf26qYe/Qfezv8oHul46uYlwjL8AAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.fd6417579de029e98cacfd8910c18299.svg";
export { ForwardRef as ReactComponent };